import type { FC } from "react";

import type {
  TInputErrorProps,
} from "@/ui/components/form/InputError/InputError.config";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib/utils";

export const InputError: FC<TInputErrorProps> = (
  {
    children,
    className,
  },
) => (
  <TextBody
    data-component="InputError"
    size={3}
    className={cn(
      "text-functional-destructive",
      className,
    )}
  >
    { children }
  </TextBody>
);

InputError.displayName = "InputError";
